import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getAllRiskRegistorVendor, removeRiskRegistorVendor } from "../../actions/riskManagement";
import Pagination from "../Pagination/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";




const VendorRiskRegister = () => {
    const { orgId } = useParams();
    const dispatch = useDispatch();
    const id = useSelector((state) => {
        return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    });
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(1);
    const [isModal, setModal] = useState(1);
    const templatesData = useSelector((state) => state?.riskManagement?.riskRegisterVendor?.data);

    useEffect(() => {
        if (id) {
            getAllRiskRegistorVendor(id, dispatch, page)
        }
    }, [id, dispatch, page])

    useEffect(() => {
        setTotalItems(templatesData?.totalRecords)
    }, [templatesData?.totalRecords])

    const removeRiskBtn = (r) => {
        let data = {
            "riskId": r._id
        }
        removeRiskRegistorVendor(id, r?.questionFormId, data, dispatch)
    }

    return (
        <div className="container-fluid risk-dashboard">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text">Third Party Risk Management</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/risk-register-vendor" className="welcome-textSmall">Risk management </Link>
                                </li>
                                <li className="breadcrumb-item">
                                    Risk Register Vendor
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="body">
                    <div className="table-responsive table-risk mt-3">
                        <table className="table mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Risk Title</th>
                                    {/* <th>Vendor</th> */}
                                    <th>Risk Level</th>
                                    <th>Risk Note</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {templatesData?.riskRegisters?.map((register, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td title={register?.title || "N/A"}
                                            style={{
                                                maxWidth: "250px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "unset",
                                            }}>{register?.title || "N/A"}</td>
                                        {/* <td>{register?.assigneeOrganisationName || "N/A"}</td> */}
                                        <td>
                                            <div className="risk-display-wrapper">
                                                <div className={`risk-indicator ${register?.riskLevel?.toLowerCase() === 'high' ? 'risk-level-high' :
                                                    register?.riskLevel?.toLowerCase() === 'medium' ? 'risk-level-medium' :
                                                        register?.riskLevel?.toLowerCase() === 'low' ? 'risk-level-low' :
                                                            'risk-level-unknown'
                                                    }`}>
                                                    <span className="risk-dot"></span>
                                                    {register?.riskLevel || "N/A"}
                                                </div>
                                            </div>
                                        </td>
                                        <td
                                            title={register?.riskNote || "N/A"}
                                            style={{
                                                maxWidth: "250px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "unset",
                                            }}>{register?.riskNote || "N/A"}</td>
                                        <td>
                                            <div className="risk-display-wrapper">
                                                <div className={`risk-indicator ${register?.status?.toLowerCase() === 'closed' ? 'risk-level-low' :
                                                    register?.status?.toLowerCase() === 'open' ? 'risk-level-high' :
                                                        register?.status?.toLowerCase() === 'pending' ? 'risk-level-warning' :
                                                            'risk-level-unknown'
                                                    }`}>
                                                    <span className="risk-dot"></span>
                                                    {register?.status?.toLowerCase() === 'active' ? 'open' :
                                                        register?.status?.toLowerCase() === 'inactive' ? 'closed' :
                                                            register?.status || "N/A"}
                                                </div>
                                            </div>
                                        </td>
                                        {/* <td>{register?.assigneeOrganisationName || "N/A"}</td> */}
                                        <td>
                                            <Link
                                                to={`risk-register-vendor-details/${register?.questionFormId}/${register?.categoryId}/${register?.questionId}`}
                                            >
                                                Show Details
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="dataTables_paginate">
                        {totalItems > 0 && (
                            <Pagination
                                className="pagination-bar"
                                currentPage={page}
                                totalCount={totalItems}
                                pageSize={10}
                                onPageChange={(page) => {
                                    setPage(page);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div
                className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal risk" ? "d-block show" : ""
                    }`}
                style={{ left: '20%', top: '20%' }}
            >
                <div className="modal-dialog" style={{ maxWidth: "400px" }} id="clientModal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Risk Management Principles
                            </h5>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setModal("")}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body pricing_page h-auto">
                            <div className="col-xl-12 col-lg-12 col-md-12 p-0">
                                <div className="card mb-2">
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="chatBoxMain mt-2">
                                                <div className="boxAChat">
                                                    <p className="mb-1">
                                                        B. Is there a third party pentest conducted for the applications anually ?
                                                    </p>
                                                    <p>
                                                        Answer : Now
                                                    </p>
                                                </div>
                                                <div className="boxBChat">
                                                    <p className="recieveMessage">
                                                        No , we have security scan and internal security testing, haven’t conducted the pentest by third party.
                                                    </p>
                                                    <p className="recieveTime">
                                                        Amezon - 02/04/2024 12:00
                                                    </p>
                                                </div>
                                                <div className="boxCChat">
                                                    <p className="recieveMessage">
                                                        No , we have security scan and internal security testing, haven’t conducted the pentest by third party.
                                                    </p>
                                                    <p className="recieveTime">
                                                        03/04/2024 12:00 -  Brandsek
                                                    </p>
                                                </div>
                                                <div className="boxBChat">
                                                    <p className="recieveMessage">
                                                        No , we have security scan and internal security testing, haven’t conducted the pentest by third party.
                                                    </p>
                                                    <p className="recieveTime">
                                                        Amezon - 02/04/2024 12:00
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="chatSendButton mt-2">
                                                <div className="d-flex w-100">
                                                    <span className="cursor">
                                                        Risk
                                                    </span>
                                                    <div className="ReplyBox">
                                                        <input placeholder="Reply"
                                                            // value={messageInput}
                                                            // onChange={(e) => setMessageInput(e.target.value)}
                                                            className="form-control border-0 inputUpdateLastest" />
                                                        <FontAwesomeIcon icon={faPaperPlane} size="lg" className="iconSend" color="#aaa"
                                                        // onClick={() => {
                                                        //     sendMessage()
                                                        // }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorRiskRegister;
